import type { ReactNode } from 'react'

export const extractNumericValue = (value: string | number | ReactNode): number | null => {
  if (typeof value === 'number') return value

  if (typeof value === 'string') {
    let cleaned = value.replace(/%/g, '').replace(/\s/g, '').trim()

    cleaned = cleaned.replace(/[^\d.,-]/g, '')

    if (!cleaned) return null

    const hasComma = cleaned.includes(',')
    const hasDot = cleaned.includes('.')

    if (hasComma && !hasDot) {
      cleaned = cleaned.replace(',', '.')
    } else if (hasDot && !hasComma) {
      cleaned = cleaned.replace(/\./g, '')
    } else if (hasComma && hasDot) {
      const lastCommaIndex = cleaned.lastIndexOf(',')
      const lastDotIndex = cleaned.lastIndexOf('.')

      if (lastCommaIndex > lastDotIndex) {
        cleaned = cleaned.replace(/\./g, '').replace(',', '.')
      } else {
        cleaned = cleaned.replace(/,/g, '')
      }
    }

    const numeric = parseFloat(cleaned)
    return isNaN(numeric) ? null : numeric
  }

  return null
}
